'use strict';

var React = require('react');

var SvgDomainNewIcon = function SvgDomainNewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 3c-.414 0-.75.336-.75.75v9c0 .414.336.75.75.75s.75-.336.75-.75v-8.25h10.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 6.25c0-.414.336-.75.75-.75h10.5c.414 0 .75.336.75.75v4.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.25h-9v5h3.25c.414 0 .75.336.75.75s-.336.75-.75.75h-4c-.414 0-.75-.336-.75-.75v-9Zm10.5.75v1h-9v-1h9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.25c0-.414.336-.75.75-.75h1.25v-1.25c0-.414.336-.75.75-.75s.75.336.75.75v1.25h1.25c.414 0 .75.336.75.75s-.336.75-.75.75h-1.25v1.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.25h-1.25c-.414 0-.75-.336-.75-.75Z"
  }));
};
SvgDomainNewIcon.displayName = "DomainNewIcon";

exports.SvgDomainNewIcon = SvgDomainNewIcon;
